import React from 'react';
import Layout from '../Layout/Layout';
import {
  GridItem,
  TextStyled,
  ButtonStyled,
} from '@nike/nike-design-system-components';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const LandingPage = () => {
  useDocumentTitle('Landing Page')

  return (
    <Layout justifyItems="center" justifyContent="center" alignContent="center" alignItems="center">
      <GridItem>
        <TextStyled appearance="title3" Component="h1" align="center" >
          Consumer Account Remediation
        </TextStyled>
      </GridItem>
      <GridItem>
        <TextStyled appearance="body2" align="center" >
          The BARtender APP give UI access to the existing BAR (Bad Actor Remediation) services. The BARtender services allow users Access to upload a list of emails or upmids and perform a remediation action via the BAR servicees.
        </TextStyled>
      </GridItem>
      <GridItem
        style={{
          paddingTop: "48px",
        }}
      >
        <ButtonStyled
          appearance="primary"
          size="medium"
          Component="a"
          href="/"
          
        >
          Sign In
        </ButtonStyled>
      </GridItem>
    </Layout>
  );
};

export default LandingPage;
